module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"linkCopy":"Copy the resultant link","copied":"Copied"},"ja":{"linkCopy":"結果のリンクをコピー","copied":"コピーしました"},"zh-hant":{"linkCopy":"將鏈接複製到結果","copied":"已複製"},"zh-hans":{"linkCopy":"将链接复制到结果","copied":"已复制"}}')
  delete Component.options._Ctor
}
